const getProjectNameApiError = (response) => {
  if (!response || response.status === 'ok') return '';

  const nameError = response.data?.name ?? response.name ?? response.errors?.name;
  if (Array.isArray(nameError)) return nameError.filter(Boolean).join('. ');
  if (typeof nameError === 'string' && nameError) return nameError;
  if (response.status === 'failed' && response.message) return response.message;

  return '';
};

export default getProjectNameApiError;
